import type { ComponentChildren } from "preact";

interface Props {
  id: string;
  class?: string;
  open?: boolean;
  children?: ComponentChildren;
}

export default function Modal({ id, class: _class, open, children }: Props) {
  return (
    <>
      <input
        id={id}
        checked={open}
        type="checkbox"
        class="modal-toggle"
      />

      <div id={`modal-${id}`} class="modal">
        <div class={`modal-box ${_class ?? ""}`}>
          {children}
        </div>

        <label class="modal-backdrop" for={id} aria-label="Fechar o modal" />
      </div>
    </>
  );
}
